import LinkCusstom from '@/components/common/LinkCusstom';
import {
  buildRequestListUrl,
  SERVICE_GROUP_LABEL,
  SERVICE_GROUPS,
} from '@/constants/Systemkey/request-type';
import SvgIcon from '@/components/common/SvgIcon';
import {
  Anvil,
  BadgeDollarSign,
  BrickWall,
  // BriefcaseBusiness,
  BrushCleaning,
  CalendarCheck,
  CalendarClock,
  CalendarDays,
  ClipboardCheck,
  ClipboardList,
  ClockPlus,
  Cog,
  Drill,
  FolderCog,
  FolderOpen,
  Gauge,
  Gem,
  GitPullRequest,
  Mail,
  // ReceiptText,
  // Send,
  ShieldAlert,
  SquareKanban,
  SquareUserRound,
  User,
  UserCog,
  UsersRound,
} from 'lucide-react';
import ROUTER from './ROUTER';

export interface MenuItem {
  key: string;
  label: any;
  tabid?: string[];
  children?: MenuItem[];
  [key: string]: any;
}
export const ListTitleRouter = () => {
  return [
    {
      key: ROUTER.THONG_TIN_TAI_KHOAN,
      label: 'Thông tin cá nhân',
    },
    // {
    //   key: ROUTER.DANH_BA_NHAN_VIEN,
    //   label: "Quản trị hệ thống - Danh bạ nhân viên",
    // },
    // {
    //   key: ROUTER.QUAN_LY_PHAN_QUYEN,
    //   label: "Quản trị hệ thống - Phân quyền",
    // },
    //Top menu
  ];
};
export const MenuItemBreadcrumbs = () => {
  return [
    {
      label: 'Đăng nhập',
      key: ROUTER?.DANG_NHAP,
      children: [],
    },
    {
      label: 'Đăng ký',
      key: ROUTER?.DANG_KY,
    },
    {
      label: 'Đổi mật khẩu',
      key: ROUTER?.DOI_MAT_KHAU,
    },
    {
      label: 'Thông tin cá nhân',
      key: ROUTER?.THONG_TIN_TAI_KHOAN,
    },
  ];
};
export const MenuItemAdmin = (): MenuItem[] => {
  return [
    {
      key: 'grp1',
      label: 'Thống kê',
      type: 'group',
      tabid: ['Dashboard'],
      children: [
        {
          label: <LinkCusstom to={ROUTER.DASHBOARD}>Dashboard</LinkCusstom>,
          key: ROUTER.DASHBOARD,
          icon: <SquareKanban size={16} />,
          tabid: ['Dashboard'],
        },
      ],
    },

    {
      key: 'grp2',
      label: 'Quản lý',
      type: 'group',
      tabid: [
        'Email Management',
        'Request Management',
        'Profile Management',
        'Schedule',
        'To Do List',
        'Customer Management',
        'Welder Management',
        'Customer Debt Management',
        'Payment Document Management',
        'Quotation Management',
        'Contract Management',
        'Procedures & Instruction Management',
        'Subcontracter Management',
        'Proposal Management',
        'File Management',
      ],
      children: [
        {
          label: 'Customer Management',
          key: 'subkey6',
          icon: <Gem size={16} />,
          tabid: [
            'Customer Management',
            'Welder Management',
            'Customer Debt Management',
            'Quotation Management',
            'Payment Document Management',
            'Contract Management',
          ],
          children: [
            {
              key: ROUTER.CUSTOMER_MANAGEMENT,
              label: (
                <LinkCusstom to={ROUTER.CUSTOMER_MANAGEMENT}>
                  Customer Management
                </LinkCusstom>
              ),
              icon: <UserCog size={16} />,
              tabid: ['Customer Management'],
            },
            {
              key: ROUTER.WELDER_MANAGEMENT,
              label: (
                <LinkCusstom to={ROUTER.WELDER_MANAGEMENT}>
                  Welder Management
                </LinkCusstom>
              ),
              icon: <Anvil size={16} />,
              tabid: ['Welder Management'],
            },
            {
              key: ROUTER.PAYMENT_MANAGEMENT,
              label: (
                <LinkCusstom to={ROUTER.PAYMENT_MANAGEMENT}>
                  Customer Debt Management
                </LinkCusstom>
              ),
              icon: <BadgeDollarSign size={16} />,
              tabid: ['Customer Debt Management'],
            },
            // {
            //   key: ROUTER.QUOTATION_MANAGEMENT,
            //   label: (
            //     <LinkCusstom to={ROUTER.QUOTATION_MANAGEMENT}>
            //       Quotation Management
            //     </LinkCusstom>
            //   ),
            //   icon: <Send size={16} />,
            //   tabid: ['Quotation Management'],
            // },
            // {
            //   key: ROUTER.PAYMENT_DOCUMENT_MANAGEMENT,
            //   label: (
            //     <LinkCusstom to={ROUTER.PAYMENT_DOCUMENT_MANAGEMENT}>
            //       Payment Document Management
            //     </LinkCusstom>
            //   ),
            //   icon: <BriefcaseBusiness size={16} />,
            //   tabid: ['Payment Document Management'],
            // },
            // {
            //   key: ROUTER.CONTRACT_MANAGEMENT,
            //   label: (
            //     <LinkCusstom to={ROUTER.CONTRACT_MANAGEMENT}>
            //       Contract Management
            //     </LinkCusstom>
            //   ),
            //   icon: <ReceiptText size={16} />,
            //   tabid: ['Contract Management'],
            // },
          ],
        },
        {
          label: (
            <LinkCusstom to={ROUTER.EMAIL_MANAGEMENT}>
              Email Management
            </LinkCusstom>
          ),
          key: ROUTER.EMAIL_MANAGEMENT,
          icon: <Mail size={16} />,
          tabid: ['Email Management'],
        },
        {
          label: <>Request Management</>,
          key: 'subkey1',
          icon: <GitPullRequest size={16} />,
          tabid: ['Request Management'],
          children: [
            ...SERVICE_GROUPS.map(service => ({
              label: (
                <LinkCusstom to={buildRequestListUrl(undefined, undefined, service)}>
                  {SERVICE_GROUP_LABEL[service]}
                </LinkCusstom>
              ),
              key: buildRequestListUrl(undefined, undefined, service),
              icon: <GitPullRequest size={16} />,
              tabid:
                service === 'INSPECTION'
                  ? ['Request Management', 'Request ManagementVT', 'Request ManagementBH']
                  : ['Request ManagementVT', 'Request ManagementBH'],
            })),
          ],
        },
        {
          key: ROUTER.PROFILE_MANAGEMENT,
          label: (
            <LinkCusstom to={ROUTER.PROFILE_MANAGEMENT}>
              Profile Management
            </LinkCusstom>
          ),
          icon: <FolderCog size={16} />,
          tabid: ['Profile Management'],
        },

        {
          key: ROUTER.PROCESS_INSSTRUCTION_MANAGEMENT,
          label: (
            <LinkCusstom to={ROUTER.PROCESS_INSSTRUCTION_MANAGEMENT}>
              Procedures & Instruction Management
            </LinkCusstom>
          ),
          icon: <ClockPlus size={16} />,
          tabid: ['Procedures & Instruction Management'],
        },
        {
          key: ROUTER.SUBCONTRACTOR_MANAGEMENT,
          label: (
            <LinkCusstom to={ROUTER.SUBCONTRACTOR_MANAGEMENT}>
              Subcontractor Management
            </LinkCusstom>
          ),
          icon: <UsersRound size={16} />,
          tabid: ['Subcontracter Management'],
        },
        {
          key: ROUTER.PROPOSAL_MANAGEMENT,
          label: (
            <LinkCusstom to={ROUTER.PROPOSAL_MANAGEMENT}>
              Proposal Management
            </LinkCusstom>
          ),
          icon: <UsersRound size={16} />,
          tabid: ['Proposal Management'],
        },

        {
          key: ROUTER.FILE_MANAGEMENT,
          label: (
            <LinkCusstom to={ROUTER.FILE_MANAGEMENT}>
              File Management
            </LinkCusstom>
          ),
          icon: <FolderOpen size={16} />,
          tabid: ['File Management'],
        },
        {
          label: 'Working Day',
          key: 'subkey8',
          icon: <CalendarDays size={16} />,
          tabid: [
            'Ticket Management',
            'My Ticket',
            'Attendace Sheet',
            'Employee Attendance Sheet',
          ],
          children: [
            {
              key: ROUTER.TICKET_MANAGEMENT,
              label: (
                <LinkCusstom to={ROUTER.TICKET_MANAGEMENT}>
                  Ticket Management
                </LinkCusstom>
              ),
              tabid: ['Ticket Management'],
              icon: <ClipboardList size={16} />,
            },

            {
              key: ROUTER.MY_TICKET,
              label: <LinkCusstom to={ROUTER.MY_TICKET}>My Ticket</LinkCusstom>,
              tabid: ['My Ticket'],
              icon: <ClipboardList size={16} />,
            },
            {
              key: ROUTER.ATTENDANC_SHEET,
              label: (
                <LinkCusstom to={ROUTER.ATTENDANC_SHEET}>
                  Attendance Sheet
                </LinkCusstom>
              ),
              tabid: ['Attendace Sheet'],
              icon: <CalendarClock size={16} />,
            },
            {
              key: ROUTER.EMPLOYEE_ATTENDANC_SHEET,
              label: (
                <LinkCusstom to={ROUTER.EMPLOYEE_ATTENDANC_SHEET}>
                  Employee Attendance Sheet
                </LinkCusstom>
              ),
              tabid: ['Employee Attendance Sheet'],
              icon: <CalendarClock size={16} />,
            },
            // {
            //   key: ROUTER.EMPLOYEE_ATTENDANCE,
            //   label: (
            //     <LinkCusstom to={ROUTER.EMPLOYEE_ATTENDANCE}>
            //       Employee Attendance
            //     </LinkCusstom>
            //   ),
            //   tabid: ['Profile'],
            //   icon: <CalendarClock size={16} />,
            // },
          ],
        },
        {
          label: <>Task Management</>,
          key: 'subkey5',
          icon: <ClipboardCheck size={16} />,
          tabid: ['Schedule', 'To Do List'],
          children: [
            {
              key: 'grp7',
              label: 'VTS Vũng Tàu',
              type: 'group',
              tabid: ['ScheduleVT', 'To Do ListVT'],
              children: [
                {
                  key: ROUTER.TO_DO_LIST,
                  label: (
                    <LinkCusstom to={ROUTER.TO_DO_LIST}>To Do List</LinkCusstom>
                  ),
                  tabid: ['To Do ListVT'],
                  icon: <ClipboardList size={16} />,
                },
                {
                  key: ROUTER.Schedule,
                  label: (
                    <LinkCusstom to={ROUTER.Schedule}>Schedule</LinkCusstom>
                  ),
                  tabid: ['ScheduleVT'],
                  icon: <CalendarCheck size={16} />,
                },
              ],
            },
            {
              key: 'grp8',
              label: 'VTS Biên Hòa',
              type: 'group',
              tabid: ['ScheduleBH', 'To Do ListBH'],
              children: [
                {
                  key: ROUTER.TO_DO_LIST_BIEN_HOA,
                  label: (
                    <LinkCusstom to={ROUTER.TO_DO_LIST_BIEN_HOA}>
                      To Do List
                    </LinkCusstom>
                  ),
                  tabid: ['To Do ListBH'],
                  icon: <ClipboardList size={16} />,
                },
                {
                  key: ROUTER.Schedule_BIEN_HOA,
                  label: (
                    <LinkCusstom to={ROUTER.Schedule_BIEN_HOA}>
                      Schedule
                    </LinkCusstom>
                  ),
                  tabid: ['ScheduleBH'],
                  icon: <CalendarCheck size={16} />,
                },
              ],
            },
          ],
        },
        {
          label: 'Devices Management',
          key: 'subkey7',
          icon: <Drill size={16} />,
          tabid: ['Equipment Management'],
          children: [
            {
              key: ROUTER.EQUIPMENT_TOOLS_MANAGEMENT,
              label: (
                <LinkCusstom to={ROUTER.EQUIPMENT_TOOLS_MANAGEMENT}>
                  Testing equipment-TBTN
                </LinkCusstom>
              ),
              icon: <Gauge size={16} />,
              tabid: ['Equipment Management'],
            },
            {
              key: ROUTER.CALIBRATION_EQUIPMENT_MANAGEMENT,
              label: (
                <LinkCusstom to={ROUTER.CALIBRATION_EQUIPMENT_MANAGEMENT}>
                  Machining equipment-TBGC
                </LinkCusstom>
              ),
              icon: <BrushCleaning size={16} />,
              tabid: ['Equipment Management'],
            },
            {
              key: ROUTER.EQUIPMENT_AND_MATERIALS_MANAGEMENT,
              label: (
                <LinkCusstom to={ROUTER.EQUIPMENT_AND_MATERIALS_MANAGEMENT}>
                  Office equipment-TBVP
                </LinkCusstom>
              ),
              icon: <BrickWall size={16} />,
              tabid: ['Equipment Management'],
            },
          ],
        },
      ],
    },

    {
      key: 'pqr-master-data',
      label: 'Master Data',
      icon: <FolderCog size={16} />,
      children: [
        {
          label: (
            <LinkCusstom to={ROUTER.MASTER_LIST}>Master List</LinkCusstom>
          ),
          key: ROUTER.MASTER_LIST,
          icon: <ClipboardList size={16} />,
          tabid: ['Request Management'],
        },
        {
          key: ROUTER.PQR_STANDARDS,
          label: (
            <LinkCusstom to={ROUTER.PQR_STANDARDS}>PqrStandards</LinkCusstom>
          ),
          icon: <Cog size={16} />,
        },
      ],
    },
    {
      key: 'grp9',
      label: 'Quản trị hệ thống',
      type: 'group',
      tabid: [
        'User Management',
        'Role Management',
        'Request Hardness Config',
        'UserInfor',
      ],
      children: [
        {
          key: ROUTER.USER_MANAGEMENT,
          label: (
            <LinkCusstom to={ROUTER.USER_MANAGEMENT}>
              User Management
            </LinkCusstom>
          ),
          tabid: ['User Management'],
          icon: <SquareUserRound size={16} />,
        },
        {
          key: ROUTER.ROLE_MANAGEMENT,
          label: (
            <LinkCusstom to={ROUTER.ROLE_MANAGEMENT}>
              Role Management
            </LinkCusstom>
          ),
          tabid: ['Role Management'],
          icon: <ShieldAlert size={16} />,
        },

        {
          label: (
            <LinkCusstom to={ROUTER.REQUEST_CONFIG}>Form mẫu báo cáo</LinkCusstom>
          ),
          key: ROUTER.REQUEST_CONFIG,
          icon: <Cog size={16} />,
          tabid: ['Request Hardness Config'],
        },

        {
          key: ROUTER.THONG_TIN_TAI_KHOAN,
          label: 'Thông tin cá nhân',
          icon: <User size={16} />,
          tabid: ['UserInfor'],
        },
      ],
    },
    // {
    //   key: 'subkey2',
    //   icon: <SquareUserRound size={16} />,
    //   label: <LinkCusstom to={ROUTER.USER_MANAGEMENT}>Quản trị hệ thống</LinkCusstom>,
    //   tabid: ['User', 'Role'],
    //   children: [
    //     {
    //       key: ROUTER.USER_MANAGEMENT,
    //       label: <LinkCusstom to={ROUTER.USER_MANAGEMENT}>Quản lý nhân sự</LinkCusstom>,
    //       tabid: ['User'],
    //     },
    //     {
    //       key: ROUTER.ROLE_MANAGEMENT,
    //       label: <LinkCusstom to={ROUTER.ROLE_MANAGEMENT}>Phân quyền</LinkCusstom>,
    //       tabid: ['Role'],
    //     },
    //   ],
    // },
  ];
};

export const MenuItemUser = () => {
  return [
    {
      key: ROUTER.THONG_TIN_TAI_KHOAN,
      label: 'Thông tin cá nhân',
      icon: <SvgIcon name="user-info" />,
      tabid: ['1'],
    },
  ];
};
const MenuItem = () => {
  return [
    {
      key: ROUTER.HOME,
      icon: <SvgIcon name="home" />,
      align: 'center',
    },
  ];
};
export default MenuItem;
